import React from 'react';
import Suppliers from '../Suppliers';

const SuppliersOverview = () => {
  return <Suppliers />;
};

export default SuppliersOverview;
